var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadedDocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_274_15018)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_274_15018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.66675 22.6667V6.33337C4.66675 4.40021 6.23358 2.83337 8.16675 2.83337H15.0908C15.8864 2.83337 16.6495 3.14944 17.2121 3.71205L22.4547 8.9547C23.0173 9.5173 23.3334 10.2804 23.3334 11.076V22.6667C23.3334 24.5999 21.7666 26.1667 19.8334 26.1667H8.16675C6.23358 26.1667 4.66675 24.5999 4.66675 22.6667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16675 22.6667V6.33337C5.16675 4.67635 6.50972 3.33337 8.16675 3.33337H15.0908C15.7538 3.33337 16.3897 3.59677 16.8585 4.06561L22.1012 9.30825C22.57 9.77709 22.8334 10.413 22.8334 11.076V22.6667C22.8334 24.3237 21.4904 25.6667 19.8334 25.6667H8.16675C6.50972 25.6667 5.16675 24.3237 5.16675 22.6667Z",
    stroke: "#DBDBDB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 9.33325,
    y: 13.9166,
    width: 9.33333,
    height: 1.16667,
    rx: 0.583333,
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.33325,
    y: 16.8334,
    width: 9.33333,
    height: 1.16667,
    rx: 0.583333,
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.33325,
    y: 19.75,
    width: 4.66667,
    height: 1.16667,
    rx: 0.583333,
    fill: "#6C6C6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.33325,
    y: 8.66663,
    width: 4.66667,
    height: 1.16667,
    rx: 0.583333,
    fill: "#DBDBDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_274_15018",
    x: 3.66675,
    y: 2.83337,
    width: 20.6667,
    height: 25.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_274_15018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_274_15018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_274_15018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadedDocument);
export default __webpack_public_path__ + "static/media/uploaded-document.61c99d8825353e60108e431a0d164c11.svg";
export { ForwardRef as ReactComponent };